export const messages = {
  username: {
    placeholder: {
      id: 'login.Form.Username.Placeholder',
      defaultMessage: 'Enter Username',
    },
  },
  password: {
    placeholder: {
      id: 'login.Form.Password.Placeholder',
      defaultMessage: 'Enter Password',
    },
  },
  login: {
    label: {
      id: 'login.Form.Login.Label',
      defaultMessage: 'Log in',
    },
  },
  usernameTitle: {
    label: {
      id: 'login.Form.UserNameTitle.Label',
      defaultMessage: 'Username',
    },
  },
  passwordTitle: {
    label: {
      id: 'login.Form.PasswordTitle.Label',
      defaultMessage: 'Password',
    },
  },
  required: {
    error: {
      id: 'login.Form.Required.Error',
      defaultMessage: 'Required',
    },
  },
  page: {
    title: {
      id: 'patientPortal.KioskLogin.Page.Title',
      defaultMessage: 'Questionnaire Kiosk',
    },
  },
};
